import { type Link } from "components/ExpandableItems/types";
import { type EngagementLineStatus } from "features/Library/Videos/state/slices/videoPerformanceSlice";
import { type Group, type User } from "interfaces";
import { type Removable, type WithId } from "types";
import { type FilterTypesMap, FilterType } from "utils/filterUtils";

export interface EmbeddedVideoOverview {
  id: number;
  title: string;
  thumbnailUrl: string;
  canBePublished: boolean;
  hasBeenPublished: boolean;
  description: string;
  isDraft: boolean;
  isPurchased: boolean;
  ownerId: number;
  publisher: string;
  dateCreated: string;
  dateModified: string;
  isLoading?: boolean;
  canBeDeleted: boolean;
  dependencies?: {
    assignmentsCount: number;
    flowsCount: number;
    packsCount: number;
  };
  visibility: boolean;
}

export enum EmbeddedVideosFiltersEnum {
  Tags = "tags",
  SoftwareApplications = "softwareApplications",
  Labels = "labels",
  Packs = "packIds",
  Publishers = "publisherIds",
  DateCreated = "dateCreated",
  DateModified = "dateModified",
}

export const embeddedVideosFilterTypes: FilterTypesMap<EmbeddedVideosFiltersEnum> = {
  dateCreated: FilterType.DateRange,
  dateModified: FilterType.DateRange,
  labels: FilterType.Array,
  packIds: FilterType.Array,
  publisherIds: FilterType.Array,
  softwareApplications: FilterType.Array,
  tags: FilterType.Array,
};

export interface Settings {
  packs: Link[];
  flows: Link[];
  labels: string[];
  softwareApplications: string[];
}

export enum EmbeddedVideoSource {
  YouTube = 1,
  Vimeo = 2,
  Wistia = 3,
  Vidyard = 4,
}

interface EmbeddedVideoPeople extends Removable, WithId {
  priorityLevelId: number;
  editable: boolean;
  permissionIssuedDate: Date;
  inherited: boolean;
}

export interface EmbeddedVideoUser extends User, EmbeddedVideoPeople {
  userId: number;
  isCompleted: boolean;
  expirationDate?: string;
}

export interface EmbeddedVideoGroup extends Group, EmbeddedVideoPeople {
  groupId: string;
}

export type EmbeddedVideoLineChart = {
  CompletedCount: number;
  CumulativeCompletedCount: number;
  CumulativeStartedCount: number;
  Date: string;
  StartedCount: number;
};

export type EmbeddedVideoEngagement = {
  CompletedCount: number;
  CompletionRate: number;
  Customers: number;
  StartedCount: number;
  Videos: number;
};

export type EmbeddedVideoPeopleDetails = {
  DateWatched?: string;
  Status: EngagementLineStatus;
  UserEmail: string;
  UserFirstName: string;
  UserId: number;
  UserLastName: string;
  VideoCompletions: number;
  VideoStarts: number;
};
